import React from 'react';
import t from '@/utils/Language/UI-translations';
import useLocation from '@/hooks/useLocation';
import Button from '@/components/Button/Button';

const FindLocation = ({ saveLocationFn, setState, additionalClasses, ...props }) => {
  const { locationContext } = useLocation();
  const { locationHelpers } = locationContext;
  const saveLocation = saveLocationFn || locationContext.updateLocationByPlace;

  const fetchCurrentLocation = () => {
    locationHelpers
      .getDetectedLocation()
      .then((location) => {
        saveLocation(location);
        if (setState) {
          setState(
            Object.assign(location, {
              center: {
                lat: location.lat,
                lng: location.lng
              }
            })
          );
        }
      })
      .catch((error) => {
        showError(error);
      });
  };

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.error('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.error('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.error('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        console.error('An unknown error occurred.');
        break;
    }
  };

  return (
    <>
      <Button
        type="link"
        additionalClasses={additionalClasses}
        onButtonClick={fetchCurrentLocation}
        text={t('Automatically find my location')}
        icon={{ style: 'fas', font: 'location-arrow', position: 'left' }}
      />
    </>
  );
};

export default FindLocation;
